import Vue from 'vue'
import Router from 'vue-router'
import routeMappers from '../../config/route'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: '/login',
      component: () => import(`../../views/${process.env.VUE_APP_INDEX_PAGE}.vue`),
      children:[
        ...routeMappers
      ]
    }
  ]
})
